import { gql } from "@apollo/client";

export const GET_DATOS_GENERALES_RI_ID = gql`
query GetDatosGeneralesRIByEvaluacionId($idEvaluacion: Int!) {
    datosGeneralesRIByEvaluacionId(
        idEvaluacion: $idEvaluacion
    )
}`;